export const useAdamAuth = () => {
  const { memberId, userId, token } = useAdamTokens();

  const isRefreshingToken = ref<boolean>(false);

  const forceRefreshToken = async () => {
    isRefreshingToken.value = true;
    try {
      await useAdamRefreshToken();
    } catch (e) {
      if (
        e.response &&
        (e.response.status === 401 ||
          e.response.status === 403 ||
          e.response.status === 412)
      ) {
        window.location.href = '/logout';
      } else {
        throw e;
      }
    }
    isRefreshingToken.value = false;
  };

  const isLoggedIn = computed<boolean>(() => {
    return memberId.value !== null && userId.value !== null;
  });

  watch(
    () => {
      return token.value;
    },
    (to, from) => {
      if (to !== from) {
        globalThis.$logger.info('useAdamAuth :: token has been updated');
      }
    },
    { immediate: true }
  );

  return {
    forceRefreshToken,
    isLoggedIn,
    memberId,
    userId,
    isRefreshingToken,
  };
};
